<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="memberOperationForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                memberOperationForm: () => import('../forms/MemberOperationForm'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Operation', value: 'operation', format: this.formatEnum },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "memberId", direction: "ascending" },
                ],
                itemsField: 'memberOperations',
                editPageName: 'memberOperation',
                apiMethod: 'MemberOperations',
                claimName: 'MemberOperations',
                formTitle: 'Member Operation',
                excelTitle: 'Member Operations',
                hasEditPage: false,
            }
        },
    };
</script>
